module.exports = __webpack_public_path__ + "img/coin-deposit.0c37b0ab.svg";